import { render, staticRenderFns } from "./EditBusinessLogisticsShippingRateView.vue?vue&type=template&id=1a36b1d8&scoped=true&"
import script from "./EditBusinessLogisticsShippingRateView.vue?vue&type=script&lang=ts&"
export * from "./EditBusinessLogisticsShippingRateView.vue?vue&type=script&lang=ts&"
import style0 from "./EditBusinessLogisticsShippingRateView.vue?vue&type=style&index=0&id=1a36b1d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a36b1d8",
  null
  
)

export default component.exports